import { RFQCreate } from "./RFQCreate";
import { RFQEdit } from "./RFQEdit";
import { RFQList } from "./RFQList";
import { RFQShow } from "./RFQShow";

export const rfqs = {
    list: RFQList,
    show: RFQShow,
    create: RFQCreate,
    edit: RFQEdit,
    recordRepresentation: 'reference'
};
